import {Component} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import "rxjs/add/operator/toPromise";
import {Observable} from "rxjs";
import {handleErrors} from "../../misc/handle-errors.decorator";
import * as uuid from "uuid";
import { toggleLoading } from "../../misc/loading.decorator";

export interface CreateFleetDialogModel {
  fleet: any[];
  fleetId: string;
  projectFleetId: string;
  projectFleetName: string;
}

@Component({
  templateUrl: "./fleet-create-dialog.template.pug",
})
export class FleetCreateDialogComponent
  extends DialogComponent<CreateFleetDialogModel, any> implements CreateFleetDialogModel {
  public fleetId: string = "";
  public fleetName: string = "";
  fleet: any[] = [];
  public error: Error;
  public projectFleetId: string = "";
  public projectFleetName: string = "";

  static showCreateFleetDialogModal(
    dialogService: DialogService,
    inputs: CreateFleetDialogModel,
  ): Observable<any> {
    return dialogService.addDialog(
      FleetCreateDialogComponent,
      inputs,
      {backdropColor: "rgba(0, 0, 0, 0.5)"},
    );
  }

  cancel(): void {
    this.result = {};
    this.close();
  }

  @handleErrors()
  async create(): Promise<void> {
    // Validate they are not trying to create an existing fleet
    const existingFleet = this.fleet.find(it => it.fleetName.toLowerCase() === this.fleetName.toLowerCase());
    if (existingFleet) {
      throw new Error("The Fleet already exists, please try again.");
    }
    this.result = {
      fleetName: this.fleetName,
      fleetId: this.fleetId,
    };
    this.close();
  }

  updateFleet() {
    this.fleetId = "";
    this.fleetName = "";
  }

    @toggleLoading()
    @handleErrors()
    async ready() {
      // if this.projectFleetId is "" then create new Fleet id
      if (this.projectFleetId === "") {
        this.fleetId = uuid.v1().replace(/-/g, "");
      } else {
        this.fleetId = this.projectFleetId;
        this.fleetName = this.projectFleetName;
      }
    }

  constructor(
    public dialogService: DialogService,
  ) {
    super(dialogService);
    this.fleetId = this.projectFleetId;
    this.fleetName = this.projectFleetName;
  }
}
